export const createProperty = (propertyKey, propertyValue) => {
  return Promise.resolve({
    [propertyKey]: propertyValue
  });
};